import { Kampos, effects } from 'kampos';
export default async function create(target, options) {
  const {
    segments = 6,
    offset = 0
  } = options.namedEffect;
  const kaleidoscope = effects.kaleidoscope({
    segments,
    offset
  });
  const instance = new Kampos({
    effects: [kaleidoscope],
    target
  });
  return {
    instance,
    play(_temp) {
      let {
        beforeDraw
      } = _temp === void 0 ? {} : _temp;
      this.instance.play(beforeDraw);
    },
    setters: {
      offset(o) {
        if (typeof o === 'number') {
          kaleidoscope.offset = {
            x: o,
            y: o
          };
        } else {
          kaleidoscope.offset = o;
        }
      },
      segments(s) {
        kaleidoscope.segments = s;
      },
      rotation(r) {
        kaleidoscope.rotation = r;
      }
    },
    resize(w, h) {
      instance.setSource({
        width: w,
        height: h
      });
    }
  };
}
//# sourceMappingURL=Kaleidoscope.js.map